<script lang="ts" setup>
import type { ConsultationSourceEnumType } from '@forgd/contract/types'
import { ConsultationSourceEnum } from '@forgd/contract/types'
import { Button } from '@forgd/ui-kit/button'

const props = withDefaults(defineProps<{
  variant?: 'dark' | 'light'
  source?: ConsultationSourceEnumType
}>(), {
  variant: 'dark',
  source: ConsultationSourceEnum.NavSidebar,
})

const { destination } = useConsultationDestination()
const { captureConsultationClick } = useConsultationTracking()

function handleClick() {
  captureConsultationClick(props.source, destination.value.to)
}
</script>

<template>
  <div
    data-el="AppNavCta"
    class="flex w-full flex-col gap-5 rounded-lg p-4"
    :class="variant === 'dark' ? 'bg-[#181C35]' : 'bg-tertiary'"
  >
    <div class="flex flex-col gap-2.5">
      <CoreToolsPictogram
        :variant="variant"
        class="shrink-0"
        :class="variant === 'dark' ? 'size-15' : 'size-10'"
      />
      <div
        class="flex flex-col text-xs leading-normal"
        :class="variant === 'dark' ? 'text-white' : 'text-primal'"
      >
        <p class="font-semibold whitespace-nowrap">
          Get a Free Consultation
        </p>
        <p class="font-normal">
          The fastest way to get on track with your token.
        </p>
      </div>
    </div>
    <Button
      as-child
      :variant="variant === 'dark' ? 'outline-inverted' : 'outline'"
      size="sm"
      class="w-full"
      :class="variant === 'dark' ? 'ring-white hover:ring-white' : ''"
    >
      <NuxtLink
        :to="destination.to"
        :external="destination.external"
        :target="destination.target"
        @click="handleClick"
      >
        Book a Consultation
      </NuxtLink>
    </Button>
  </div>
</template>
